/**
 * @generated SignedSource<<0573196ec7738d82c63b8fb99e62b3d0>>
 * @relayHash b63a9ec435b70ffc0514a62a7f243812
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/545.0.0-2026-02-04T17:00:35.083Z/designerDirectoryRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignFirmsSortByTypes = "FIRM_NAME_ASC" | "FIRM_NAME_DESC" | "PROJECT_PUBLISH_DATE_ASC" | "PROJECT_PUBLISH_DATE_DESC" | "RANKED" | "%future added value";
export type designerDirectoryRootQuery$variables = {
  hasSearch: boolean;
  page?: number | null;
  pageStartOffset?: number | null;
  regionCodes?: ReadonlyArray<string | null> | null;
  resultsPerPage?: number | null;
  search?: string | null;
  showOnlyTpnFirms?: boolean | null;
  showTestFirms?: boolean | null;
  sortBy?: DesignFirmsSortByTypes | null;
};
export type designerDirectoryRootQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectoryWrapper_viewer">;
  };
};
export type designerDirectoryRootQuery = {
  response: designerDirectoryRootQuery$data;
  variables: designerDirectoryRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSearch"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageStartOffset"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regionCodes"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resultsPerPage"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showOnlyTpnFirms"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showTestFirms"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v9 = {
  "kind": "Variable",
  "name": "showOnlyTpnFirms",
  "variableName": "showOnlyTpnFirms"
},
v10 = {
  "kind": "Variable",
  "name": "showTestFirms",
  "variableName": "showTestFirms"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "designerDirectoryRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DesignerDirectoryWrapper_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "designerDirectoryRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "hasSearch",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "designFirmResults",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "firmName",
                    "variableName": "search"
                  },
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "concreteType": "DirectoryDesignFirmConnection",
                "kind": "LinkedField",
                "name": "designFirms",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DirectoryDesignFirmEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DirectoryDesignFirm",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DesignFirmPublicProfile",
                            "kind": "LinkedField",
                            "name": "publicProfile",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "regionType",
                "value": "TRADE_FIRM_REGION"
              }
            ],
            "concreteType": "Region",
            "kind": "LinkedField",
            "name": "regions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "regionName",
                "storageKey": null
              },
              (v13/*: any*/)
            ],
            "storageKey": "regions(regionType:\"TRADE_FIRM_REGION\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "resultsPerPage"
              },
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page"
              },
              {
                "kind": "Variable",
                "name": "pageStartOffset",
                "variableName": "pageStartOffset"
              },
              {
                "kind": "Variable",
                "name": "regionCodes",
                "variableName": "regionCodes"
              },
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "kind": "Variable",
                "name": "sortBy",
                "variableName": "sortBy"
              }
            ],
            "concreteType": "DirectoryDesignFirmConnection",
            "kind": "LinkedField",
            "name": "designFirms",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalResults",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DirectoryDesignFirmEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DirectoryDesignFirm",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "serviceId",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DesignFirmDirectoryProfile",
                        "kind": "LinkedField",
                        "name": "directoryProfile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activeProjectCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "city",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "country",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "profilePhoto",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectCoverPhotos",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DesignFirmPublicProfile",
                        "kind": "LinkedField",
                        "name": "publicProfile",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/545.0.0-2026-02-04T17:00:35.083Z/designerDirectoryRootQuery",
    "metadata": {},
    "name": "designerDirectoryRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1d507bebea73acdc6b2ff7eac9952b8c";

export default node;
